import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import DSDialog from "views/system-design/DSDialog";
import DSDialogTitle from "views/system-design/DSDialogTitle";
import DSDialogContent from "views/system-design/DSDialogContent";
import DSDialogActions from "views/system-design/DSDialogActions";
import DSTypography from "views/system-design/DSTypography";
import DSButton from "views/system-design/DSButton";
import DSErrorButton from "views/system-design/DSErrorButton";
import DSCircularProgress from "views/system-design/DSCircularProgress";

interface DeleteStoryDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  deleting: boolean;
  storyName: string;
}

const DeleteStoryDialog: React.FC<DeleteStoryDialogProps> = ({
  open,
  onClose,
  onConfirm,
  deleting,
  storyName,
}) => {
  return (
    <DSDialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DSDialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        Delete Story
        <CloseIcon sx={{ cursor: "pointer" }} onClick={onClose} />
      </DSDialogTitle>
      <DSDialogContent>
        <DSTypography>
          Are you sure you want to delete "{storyName}"? This action cannot be
          undone.
        </DSTypography>
      </DSDialogContent>
      <DSDialogActions>
        <DSButton type="button" variant="text" onClick={onClose}>
          Cancel
        </DSButton>
        <DSErrorButton onClick={onConfirm} disabled={deleting}>
          {deleting ? <DSCircularProgress size={20} /> : "Delete"}
        </DSErrorButton>
      </DSDialogActions>
    </DSDialog>
  );
};

export default DeleteStoryDialog;
